import { useEffect } from "react";

export const Viyog = ({ onClose }) => {
    useEffect(() => {
        // Function to handle keydown event
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose(); // Call the onClose function when Esc is pressed
            }
        };

        // Add event listener when the component mounts
        window.addEventListener("keydown", handleKeyDown);

        // Clean up event listener when the component unmounts
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [onClose]);

    return (
        <>
            <div
                className="modal"
                style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "rgba(0, 0, 0, 0.5)", position: "fixed", top: 0, left: 0, width: "100%", height: "100%", overflowY: "auto", // Enable scrolling for the modal
                    zIndex: 1050, }}
            >
                <div
                    className="modal-content"
                    style={{
                        padding: "20px", background: "#fff", borderRadius: "8px", maxWidth: "500px", width: "95%", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)", maxHeight: "95vh", // Limit the modal height to viewport
                        overflowY: "auto", // Enable content scrolling within the modal 
                    }}
                >
                    <div className="img-fluid mb-4">
                        <picture>
                            <img
                                src="/media/poemsmar/viyog.jpg"
                                alt=" वियोग | Lone Wolf writes"
                                style={{
                                    width: "100%",
                                    height: "18rem",
                                    objectFit: "cover",
                                    borderRadius: "6px",
                                    backgroundColor: "gray",
                                }}
                            />
                        </picture>
                    </div>

                    <h2 style={{ textAlign: "center", color: "red" }}>वियोग</h2>
                    <hr />

                    <p style={{ textAlign: "center" }}>
                        का सोडलीस हाथ माझा?<br />
                        का सोडलीस साथ माझा?<br />
                        राहिलीस सोबत तू फक्त आठवणीवजा.<br />
                        <br />
                        गरज आहे मला, तुझी आज फार<br />
                        खुले आहे तुझंकारिता, मनाचे या द्वार<br />
                        <br />
                        'साथ ना सोडेन कधी', दिधले होतेस वचन मज<br />
                        मग गेलीस कोठे तू, सोडून एकाकी आज?<br />
                        <br />
                        शोधतो आहे तुला, प्रत्येक नवीन चेहऱ्यात<br />
                        कसे सांगू असतो, नेहमी तुझ्याच विचारात<br />
                        <br />
                        प्रेम करतो मी तुझ्यावर, खर्च अपरंपार<br />
                        दाखवू कसे ते? सांग तरी आज..<br />
                        <br />
                        ना बुडणार कधी हि प्रेमनौका, हा विश्वास होता<br />
                        फक्त तुझ्यासाठीच, जगणायचा हा ध्यास होता<br />
                        <br />
                        ना आस जगण्याची, ना तम जीवनाची<br />
                        ओढ मनाला माझ्या, फक्त तुझ्या मिलनाची<br />
                        <br />
                        कशी विसरू तुझ्या प्रेमाची ती जादू?<br />
                        तुझ्याशिवाय ना वाटते, कोणास काय मागू<br />
                        <br />
                        केली कितीही कोणाशी तुलना जरी<br />
                        तूच माझी स्वप्नपरी<br />
                        भावना माझ्या ना पोहचवू शकेन अक्षरी<br />
                        विचार मनात फक्त तुझाच तरी<br />
                        <br />
                        'सांत्वनांचाही नाही होतो आहे<br />
                        काही उपयोग<br />
                        नाही होतो गं सहन<br />
                        प्रिये तुझा वियोग'<br />
                    </p>

                    <div className="modal-footer" style={{ textAlign: "right" }}>
                        <button type="button" onClick={onClose} className="btn btn-secondary" style={{ backgroundColor: "red", border: 0, padding: "10px 20px", color: "#fff", borderRadius: "5px", }}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};
